export interface TrafficStats {
  duration: number;
  startDate: Date;
  successCount: number;
  successBytes: number;
  errorCount: number;
  errorBytes: number;
}
